import { render, staticRenderFns } from "./Luckdraw.vue?vue&type=template&id=c0776cfa&scoped=true&"
import script from "./Luckdraw.vue?vue&type=script&lang=js&"
export * from "./Luckdraw.vue?vue&type=script&lang=js&"
import style0 from "./Luckdraw.vue?vue&type=style&index=0&id=c0776cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0776cfa",
  null
  
)

export default component.exports